import script from "./OnboardingStep.vue?vue&type=script&setup=true&lang=ts"
export * from "./OnboardingStep.vue?vue&type=script&setup=true&lang=ts"

import "./OnboardingStep.vue?vue&type=style&index=0&id=027c64bc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-027c64bc"]])

export default __exports__